interface CreateProjectCardProps {
  onClick: () => void;
}

export function CreateProjectCard({ onClick }: CreateProjectCardProps) {
  return (
    <button
      type="button"
      className="project-card project-card-create"
      onClick={onClick}
      aria-label="Create a new project"
    >
      <div className="project-card-icon project-card-create-icon">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true">
          <rect
            x="2"
            y="2"
            width="28"
            height="28"
            rx="8"
            fill="currentColor"
            opacity="0.12"
          />
          <path
            d="M16 9v14M9 16h14"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <div className="project-card-content">
        <h3 className="project-card-name">New project</h3>
      </div>
    </button>
  );
}
